<template>
  <div class="mb-5">
    <div v-if="magazineName">
      <h2 class="font-weight-bolder text-primary my-3 h5">
          {{ magazineName }}
          <span v-if="issuesTobeDisplayed?.length">{{ $t('Issues.collection') }}</span>
      </h2>
    </div>
    <div class="pocList-wrapper" v-if="(issuesTobeDisplayed?.length || brands?.length)">
      <div
        class="splide columnSplide"
        :class="randomId"
        :id="'splide' + randomId"
        :aria-label="magazineName ? magazineName + ' slider' : 'magazin slider'"
        ref="splideSlider"
      >
        <div class="splide__track mask-container">
          <div class="splide__list">
            <!-- Issues -->
            <span v-for="(singleIssue, index) in issuesTobeDisplayed" :key="'issue-' + index" class="splide__slide">
              <a :href="[magazineBaseSlug + singleIssue?.brand?.slug + '/' +singleIssue.slug]" class="h-100">
                <img
                  class="card-img-top rounded-top home-issue-image-h"
                  :src="singleIssue?.cover?.xxx || defaultBrandImage"
                  :alt="singleIssue?.brand?.name + ' ' + singleIssue.designation"
                />
                <div class="my-3 text-dark">
                  <strong>{{ singleIssue?.brand?.name }}</strong><br />
                  {{ singleIssue.designation }}
                </div>
              </a>
            </span>
            <!-- Brands -->
            <span v-for="(brand, index) in brands" :key="'brand-' + index" class="splide__slide">
              <a :href="[magazineBaseSlug + brand.slug]" class="h-100">
                <img
                  class="card-img-top rounded-top home-issue-image-h"
                  :src="brand.latestIssue?.cover?.x || defaultBrandImage"
                  :alt="brand.name + ' ' + (brand.latestIssue?.designation || '')"
                />
              </a>
            </span>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import {
  ApolloClient,
  InMemoryCache
} from '@apollo/client/core';
import Splide from '@splidejs/splide';
import CONCORD_QUERIES from '../../services/concord_queries.js';

export default {
  name: "magazinesFeature",
  props: {
    settingsPerm: Object,
    brandData: Object,
    displayLatestBrands: {
      type: Boolean,
      default: false
    },
    perPageBreakpoints: {
      type: Object,
      default: () => ({
        default: 4,
        1600: 4,
        1280: 3,
        991: 3,
        767: 2,
        575: 2
      })
    }
  },
  data() {
    return {
      magazineName: '',
      issuesTobeDisplayed: [],
      randomId: Math.random().toString(36).substring(2, 15),
      splide: null,
      defaultBrandImage: '/wp-content/themes/understrap-child/reader-web-app-angular/assets/images/LoadingIssue1.svg',
      page: 1,
      pageSize: 8,
      metaCount: 0,
      sliderPerPage: 6,
      brands: [],
      seeMoreSlug: '/magazines',
      magazineBaseSlug: '/magazine-ebooks/',
    }
  },
  components: {
  },
  created() {
    if (this.brandData && this.brandData.magazines && this.brandData.magazines.length) {
      //call get brand magazines
      this.getBrandMagazines();
    }
    if (this.displayLatestBrands) {
      this.getLatestBrands();
    }
    if (this.settingsPerm.isDevMioActive) {
      this.magazineBaseSlug = '/magazines/';
    }
  },

  methods: {

    getBrandMagazines() {
      this.magazineName = this.brandData.magazines[0]?.name;
      this.getMagazinesIssues(this.brandData.magazines);
      this.seeMoreSlug = '/magazines/'+this.brandData.magazines[0]?.slug;
    },
    async getMagazinesIssues(magazines) {
      if (magazines && magazines.length && magazines[0] && magazines[0]._id) {
        const cache = new InMemoryCache();
        const customHeaders = {
          platform: "web",
          App: this.settingsPerm.isDevMioActive ? "devmio" : "entwickler"
        };
        const apolloClient = new ApolloClient({
          cache,
          uri: this.settingsPerm.concordBackendURL,
          headers: customHeaders,
        });

        try {
          const { data } = await apolloClient.query({
            query: CONCORD_QUERIES.GET_BRAND_ISSUES_BY_MAGAZINE_ID,
            variables: {
              brandId: magazines[0]._id,
              page: this.page,
              pageSize: this.pageSize
            },
            fetchPolicy: 'network-only'
          });

          if (data?.issues?.Issues?.length > 0) {
            this.metaCount = data.issues.Meta?.count;
            let isCompletedIssues = data.issues.Issues.filter(issue => issue.isIssueCompleted);
            this.issuesTobeDisplayed = [...this.issuesTobeDisplayed, ...isCompletedIssues];
            this.$nextTick(() => {
              if (!this.splide) {
                this.mountSplide();
              } else {
                this.splide.refresh();
              }
            });
          }
        } catch (error) {
          console.error("Error fetching brand issues:", error);
        }
      }
    },
    async getLatestBrands() {
      this.magazineName = this.settingsPerm.isDevMioActive
        ? 'Discover Your Library'
        : 'Entdecke die Bibliothek';

      const cache = new InMemoryCache();
      const customHeaders = {
        platform: "web",
        App: this.settingsPerm.isDevMioActive ? "devmio" : "entwickler"
      };
      const apolloClient = new ApolloClient({
        cache,
        uri: this.settingsPerm.concordBackendURL,
        headers: customHeaders,
      });

      try {
        const { data } = await apolloClient.query({
          query: CONCORD_QUERIES.MAGAZINE_EBOOKS_BX,
          fetchPolicy: 'network-only'
        });

        if (data?.brands?.Brands?.length > 0) {
          this.brands = data.brands.Brands.filter(brand => brand.latestIssue?.isIssueCompleted);
          this.$nextTick(() => {
            if (!this.splide) {
              this.mountSplide();
            } else {
              this.splide.refresh();
            }
          });
        }
      } catch (error) {
        console.error("Error fetching latest brands:", error);
      }
    },
    mountSplide() {
      let thiz = this;
      let padding = {
        right: "0rem",
        left: "0rem",
      };

      setTimeout(function () {
        if (thiz.issuesTobeDisplayed && thiz.issuesTobeDisplayed.length && thiz.issuesTobeDisplayed.length > 3) {
          padding = {
            right: "0rem",
            left: "0rem",
          };
        }

        if (!thiz.splide) {
          thiz.splide = new Splide(`#splide${thiz.randomId}`, {
            classes: {
              arrows: 'splide__arrows arrows',
              arrow: 'splide__arrow arrow',
              prev: 'splide__arrow--prev prev',
              next: 'splide__arrow--next next',
            },
            perPage: thiz.perPageBreakpoints.default,
            perMove: 1,
            gap: '1rem',
            rewind: false,
            pagination: false,
            padding: padding,
            breakpoints: {
              1600: { perPage: thiz.perPageBreakpoints[1600] },
              1280: { perPage: thiz.perPageBreakpoints[1280] },
              991: { perPage: thiz.perPageBreakpoints[991] },
              767: { 
                perPage: thiz.perPageBreakpoints[767],
              },
              575: {
                perPage: thiz.perPageBreakpoints[575],
                arrows: false,
                padding: { left: "0rem", right: "5rem" },
                start: 0,
              },
              480: {
                perPage: 1,
                arrows: false,
                padding: { left: "0rem", right: "5rem" },
                start: 0,
              },
            },
          });

          thiz.splide.on("moved", (newIndex) => {
            const lastCardIndex = newIndex + thiz.sliderPerPage;
            if (thiz.issuesTobeDisplayed.length < thiz.metaCount && lastCardIndex >= thiz.issuesTobeDisplayed.length - 1) {
              thiz.page++;
               thiz.getMagazinesIssues(thiz.brandData.magazines);
            }
          });

          thiz.splide.mount();
        } else {
          thiz.splide.refresh(); // refresh existing instance
        }
      }, 500);
    }
  }
};
</script>

<style scoped>
  .home-issue-image-h{
      max-height: 349px;
  }
</style>
